class GtmService {
	getGtmParams(theme) {
		const gtmId = theme.modules['gtm'] && theme.modules['gtm']['id'];
		if (gtmId) {
			return {id: gtmId}
		}
	}
}

const gtmService = new GtmService();
export default gtmService;
